import { FormRowType } from 'framework/form';

export type FormRowProps = {
  type: FormRowType;
  fields: Record<string, any>[];
};

export enum CustomForm {
  CREATE_LEAVE = 'CREATE_LEAVE',
  CREATE_HIRING_REQUEST_VACANCY = 'CREATE_HIRING_REQUEST_VACANCY',
  NEW_REQUEST_VACANCY = 'NEW_REQUEST_VACANCY',
  CREATE_CAREER_DEVELOPMENT_REVIEW = 'CREATE_CAREER_DEVELOPMENT_REVIEW',
  PURCHASE_INVENTORY = 'IM01',
  CREATE_BUDGET_REALLOCATION = 'CREATE_BUDGET_REALLOCATION',
  CREATE_VENDOR = 'CREATE_VENDOR',
  PURCHASE_REQUEST = 'PURCHASE_REQUEST',
  WORKLOAD_REPORTING_ISSUES = 'WORKLOAD_REPORTING_ISSUES',
}
